import type { I18nLocale } from '#/i18n/types/I18nLocale';

export const searchOrgsRoutePathByLocale = {
  en: '/en/organizations',
  es: '/es/organizaciones',
  pt: '/pt/organizacoes',
} satisfies Record<I18nLocale, string>;

export const searchOrgsRoutePaths = Object.values(searchOrgsRoutePathByLocale);

export const searchOrgsRoutePathsWithoutLang = Array.from(
  new Set(searchOrgsRoutePaths.map((path) => path.substring(3))),
);
